import { styled } from '@mui/material/styles';
import { Grid } from '@mui/material';

export const SwitchGrid = styled(Grid)`
  margin-left: -15px;
`;